export default "__VITE_ASSET__DOQAND1f__"